
import React from 'react';
import { useLanguage } from '../App';

const PrivacyPage: React.FC = () => {
  const { t } = useLanguage();
  return (
    <div className="bg-primary min-h-screen pt-32 sm:pt-48 pb-24 px-6 overflow-hidden">
      <div className="max-w-3xl mx-auto reveal reveal-up active">
        <h1 className="text-4xl sm:text-7xl font-serif font-bold uppercase accent-text-gradient tracking-widest mb-12">Privacy Policy</h1>
        
        <div className="space-y-12 text-white/60 leading-relaxed font-light text-lg">
          <section>
            <h2 className="text-white text-xl font-serif font-bold uppercase tracking-widest mb-4">Introduction</h2>
            <p>At Santi Bladez, we respect your privacy and are committed to protecting your personal data. This policy explains how we handle your information when you visit our site or book a concierge session.</p>
          </section>

          <section>
            <h2 className="text-white text-xl font-serif font-bold uppercase tracking-widest mb-4">Information We Collect</h2>
            <p>When you book an appointment, we collect your name, phone number, email, and the location for the house call. This data is used exclusively to facilitate your service.</p>
          </section>

          <section>
            <h2 className="text-white text-xl font-serif font-bold uppercase tracking-widest mb-4">How We Use Your Data</h2>
            <ul className="list-disc pl-5 space-y-3">
              <li>To manage and schedule your concierge appointments.</li>
              <li>To communicate important updates regarding your session.</li>
              <li>To improve our mobile grooming services based on your feedback.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-white text-xl font-serif font-bold uppercase tracking-widest mb-4">Third-Party Services</h2>
            <p>We use trusted third-party booking platforms (like Booksy). Their use of your data is governed by their own privacy policies which we recommend you review.</p>
          </section>

          <section className="pt-12 border-t border-white/5">
            <p className="text-xs uppercase tracking-widest font-black text-accent/40">Last Updated: October 2024</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage;
